import React, { useEffect, useLayoutEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import organizactionicon from "../../assets/images/organizactionicon.svg";

import {
  commonservices,
  ORGANIZATION_TITLE,
} from "../../services/CommonServices";
import {
  getLoginDataUsingToken,
  SubscriberInviteLogin,
} from "../../services/ReduxTookit/Slice/LoginRedux";
import { organizations } from "../../services/ReduxTookit/UserInfoSlice";

function ServicesMenu({ handleshowPopup }) {
  let dispatch = useDispatch();
  let Userdata = useSelector(
    (state) => state?.userredux?.GetByPrimarykeyData?.data?.data?.data
  );
  let UserInfo = useSelector((state) => state?.userinfo?.UserInfo);

  const OrganizationList = useSelector(
    (state) => state?.userinfo?.Organizations
  );
  const fnUpdateORG = () => {
    let body = {
      loginfrom: DevRoute ? "Developer" : "DataFactory",
    };
    dispatch(getLoginDataUsingToken(body))?.then((response) => {
      if (response?.payload?.isValidate) {
        dispatch(organizations(response?.payload?.data?.data?.dataList3));
      }
    });
  };
  let OrgList =
    Array.isArray(OrganizationList) && OrganizationList.length > 0
      ? OrganizationList
      : [];

  const navigate = useNavigate();

  let DevRoute = window.location.href.includes(`${process.env.REACT_APP_DEV}`);
  let WorkflowRoute = window.location.href.includes(
    `${process.env.REACT_APP_WORKFLOW}`
  );
  const [SelectedOrgTitle, setSelectedOrgTitle] = useState(
    DevRoute ? "Developer" : WorkflowRoute ? "Workflow" : "Community"
  );
  const [SelectedMainOrg, setSelectedMainOrg] = useState("");

  useEffect(() => {
    if (OrgList?.length > 0) {
      let temp = OrgList?.find(
        (f) => f.subscriberid === Userdata?.subscriberid
      );
      setSelectedMainOrg(
        temp?.companyname ? temp?.companyname : temp?.subscribername
      );
      // setSelectedMainOrg(temp?.companyname);
    }
  }, []);
  useLayoutEffect(() => {
    fnUpdateORG();
  }, []);

  const ForwardTo = (path) => {
    if (path === "Workflow") {
      if (Userdata?.isclient) {
        window.open(process.env.REACT_APP_WORKFLOW, "_blank");
      } else {
        navigate("/management-listing", {
          state: "membership",
        });
      }
    }
    if (path === "Developer") {
      if (Userdata?.isdeveloper) {
        window.open(process.env.REACT_APP_DEV, "_blank");
      } else {
        navigate("/management-listing", {
          state: "membership",
        });
      }
    }
    handleshowPopup();
  };
  const fnOtherOrg = (org, title) => {
    let body = {
      userid: Userdata?.userid,
      subscriberid: org?.subscriberid,
      loginto: title === "Workflow" ? "Datafactory" : title,
      logintype: Userdata?.logintype,
    };
    if (DevRoute) {
      if (title === "Workflow") {
        dispatch(SubscriberInviteLogin(body))?.then((response) => {
          if (response?.payload?.isValidate) {
            const df_token =
              response?.payload?.data?.data?.dataList1[0]?.accesstoken;

            if (df_token) {
              const URL = `${process.env.REACT_APP_WORKFLOW}/continue?df_token=${df_token}`;

              window.open(URL, "_blank");
            }
          }
        });
      } else if (title === "Developer") {
        if (org?.subscriberid !== Userdata?.subscriberid) {
          dispatch(SubscriberInviteLogin(body))?.then((response) => {
            if (response?.payload?.isValidate) {
              const df_token =
                response?.payload?.data?.data?.dataList1[0]?.accesstoken;
              window.open(
                `${process.env.REACT_APP_DEV}/continue?df_token=${df_token}`,
                "_self"
              );
            }
          });
        }
      } else if (title === "Community") {
        window.open("www.google.com", "_blank");
      }
    }
    if (WorkflowRoute) {
      if (title === "Workflow") {
        if (org?.subscriberid !== Userdata?.subscriberid) {
          dispatch(SubscriberInviteLogin(body))?.then((response) => {
            if (response?.payload?.isValidate) {
              const df_token =
                response?.payload?.data?.data?.dataList1[0]?.accesstoken;
              window.open(
                `${process.env.REACT_APP_WORKFLOW}/continue?df_token=${df_token}`,
                "_self"
              );
            }
          });
        }
      } else if (title === "Developer") {
        dispatch(SubscriberInviteLogin(body))?.then((response) => {
          if (response?.payload?.isValidate) {
            const df_token =
              response?.payload?.data?.data?.dataList1[0]?.accesstoken;
            window.open(
              `${process.env.REACT_APP_DEV}/continue?df_token=${df_token}`,
              "_blank"
            );
          }
        });
      } else if (title === "Community") {
        window.open("www.google.com", "_blank");
      }
    }
  };
  const fnRedirectORGTitle = (org, title) => {
    if (title === "Community") {
      const URL = `${process.env.REACT_APP_COMM}?df_token=${UserInfo?.uid}`;
      window.open(URL, "_blank");
    } else {
      fnOtherOrg(org, title);
    }

    // if (org?.subscriberid === Userdata?.subscriberid) {
    //   ForwardTo(title);
    // } else {
    //   fnOtherOrg(org, title);
    // }
  };
  const fnIsActive = (orgtitle, orgvalue, type) => {
    if (type === "disable") {
      if (
        WorkflowRoute &&
        orgtitle === "Workflow" &&
        Userdata?.subscriberid === orgvalue?.subscriberid
      ) {
        return "";
      } else if (
        DevRoute &&
        orgtitle === "Developer" &&
        Userdata?.subscriberid === orgvalue?.subscriberid
      ) {
        return "";
      } else if (orgvalue?.developerroleid && orgtitle === "Developer") {
        return "";
      } else if (orgvalue?.workflowroleid && orgtitle === "Workflow") {
        return "";
      } else if (
        orgtitle === "Community" &&
        orgvalue?.subscriberid === UserInfo?.primarysubscriberid
      ) {
        return "";
      } else {
        return "disable";
      }
    }
    if (type === "active") {
      if (
        WorkflowRoute &&
        orgtitle === "Workflow" &&
        Userdata?.subscriberid === orgvalue?.subscriberid
      ) {
        return "active";
      } else if (
        DevRoute &&
        orgtitle === "Developer" &&
        Userdata?.subscriberid === orgvalue?.subscriberid
      ) {
        return "active";
      }
    }
  };
  const fnHandleOrg = (orgvalues, type) => {
    if (type === "title") {
      setSelectedOrgTitle(orgvalues);
    } else if (type === "list") {
      // setSelectedMainOrg(orgvalues?.companyname);
      setSelectedMainOrg(
        orgvalues?.companyname
          ? orgvalues?.companyname
          : orgvalues?.subscribername
      );
    }
  };

  return (
    <div className="schedular-popup org-switching popmenu-main">
      <div className="popup-body">
        {/* {DevRoute && (
          <div
            className="popupmenu-inner-detail d-flex "
            onClick={() => {
              ForwardTo("workflow");
            }}
            style={{ cursor: "pointer" }}
          >
            <div>
              <img src={Workflow} alt="Workflow" />
            </div>
            <div className="ms-2">
              <h4>Workflow</h4>
              <p>
                Save your current progress on the workflow without publishing or
                changes.
              </p>
            </div>
          </div>
        )}
        {WorkflowRoute && (
          <div
            className="popupmenu-inner-detail d-flex "
            onClick={() => {
              ForwardTo("developer");
            }}
            style={{ cursor: "pointer" }}
          >
            <div>
              <img src={machinedeveloper} alt="machinedeveloper" />
            </div>
            <div className="ms-2">
              <h4>Machine Developer</h4>
              <p>
                Save your current progress on the workflow without publishing or
                changes.
              </p>
            </div>
          </div>
        )} */}
        {OrgList?.length > 0 &&
          OrgList?.map((item, index) => (
            <div
              key={index}
              className={`popupmenu-inner-detail d-flex  ${
                Userdata?.subscriberid === item?.subscriberid && "active"
              }`}
              onClick={(e) => fnHandleOrg(item, "list")}
              // onClick={() => {
              //   ForwardTo();
              // }}
            >
              <div></div>
              <div className=" w-100">
                <div className=" main-sectionmanu">
                  <img src={organizactionicon} alt="organizactionicon" />
                  <h4>
                    {item?.subscribername}{" "}
                    {item?.companyname && <>({item?.companyname})</>}
                  </h4>
                </div>
                <div className=" d-flex justify-content-around align-items-center">
                  {ORGANIZATION_TITLE?.map((item_o, index_o) => (
                    <Button
                      className={`cursor-pointer ${fnIsActive(
                        item_o,
                        item,
                        "active"
                      )} `}
                      key={index_o}
                      disabled={fnIsActive(item_o, item, "disable")}
                      onClick={(e) => {
                        e.preventDefault();
                        fnHandleOrg(item_o, "title");
                        fnRedirectORGTitle(item, item_o);
                        // ForwardTo(item_o);
                      }}
                    >
                      <div className="organizactionbutton-inner">
                        {commonservices.fnORGIcon(item_o)}
                      </div>
                      {item_o === "Workflow" ? "Data Factory" : item_o}
                    </Button>
                  ))}
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}

export default ServicesMenu;
